import { Check, Monitor, Moon, Sun } from 'lucide-react'
import type { LucideIcon } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import { Menu, MenuItem } from '../components/ui/menu'
import { THEME_MODES, useThemeStore, type ThemeMode } from './theme-store'

export const MODE_ICONS: Record<ThemeMode, LucideIcon> = {
  system: Monitor,
  light: Sun,
  dark: Moon,
}

export function ThemeToggle() {
  const { t } = useTranslation()
  const mode = useThemeStore((state) => state.mode)
  const resolved = useThemeStore((state) => state.resolved)
  const setMode = useThemeStore((state) => state.setMode)

  // The button shows what is on screen, the menu shows what was chosen — under
  // `system` those differ, and hiding that would make the toggle feel broken.
  const TriggerIcon = resolved === 'dark' ? Moon : Sun

  return (
    <Menu
      label={t('common:theme.label')}
      trigger={() => (
        <span className="flex h-9 w-9 items-center justify-center rounded-md text-foreground-muted transition-colors hover:bg-surface-hover hover:text-foreground">
          <TriggerIcon aria-hidden className="h-4 w-4" />
        </span>
      )}
    >
      {(close) => (
        <>
          {THEME_MODES.map((candidate) => {
            const Icon = MODE_ICONS[candidate]
            return (
              <MenuItem
                key={candidate}
                selected={candidate === mode}
                onSelect={() => {
                  setMode(candidate)
                  close()
                }}
              >
                <Icon aria-hidden className="h-3.5 w-3.5" />
                <span className="flex-1">{t(`common:theme.${candidate}`)}</span>
                {candidate === mode ? <Check aria-hidden className="h-3.5 w-3.5" /> : null}
              </MenuItem>
            )
          })}
        </>
      )}
    </Menu>
  )
}
